/**
 * Created by quikr on 7/22/16.
 */

import {beginAjaxCall} from "./ajaxStatusActions";
import _ApiCli from "../../helpers/ApiCli";
import Constants from "../../classes/constants";

let Ajaxcall = new _ApiCli();


const Emp = {
  "name": "dsafds",
  "empno": "adsf",
  "doj": "",
  "rep": "",
  "cont": "",
  "emer": "",
  "manager": false,
  "redirectToFeedback":false

};

export function storeEmp(emp) {
  return {type: 'GET_EMP_SUCCESS', emp};
}
export function store() {
  return function (dispatch) {
    dispatch(beginAjaxCall());

     let call1 = Ajaxcall.asyncAction("/about", 'get', null, null, dispatch);

    call1.then((response)=> {


      let new_Emp = response.data;
      Emp.empno = new_Emp.data.employeeCode;
      Emp.name = new_Emp.data.name;
      Emp.doj = new_Emp.data.dateOfJoining;
      Emp.rep = new_Emp.data.reportingTo;
      Emp.cont = new_Emp.data.contactNo;
      let call6 = Ajaxcall.asyncAction("/personal?q="+Emp.empno, 'get', null, null, dispatch);
      Emp.function = new_Emp.data.function;
      Emp.verticalHead = new_Emp.data.verticalHead;
      Emp.verticalName = new_Emp.data.vertical;
      Emp.status = new_Emp.data.empStatus ? new_Emp.data.empStatus : null;
      Emp.imageUrl = new_Emp.data.imageUrl ? new_Emp.data.imageUrl : Constants.defaultProfilePicture[0];

      //hashHistory.push("/1/home");
      Emp.superAdmin = false;
      Emp.admin = false;
      Emp.hr = false;
      Emp.finance = false;
      Emp.it = false;
      if(new_Emp.data.roles == null || new_Emp.data.roles == undefined)
      {
        Emp.superAdmin = false;
        Emp.it = false;
        Emp.hr = false;
        Emp.finance = false;
        Emp.admin = false;
        Emp.hrbp = false;
        Emp.recruiter = false;
        Emp.roster = false;
        Emp.inspector = false;
        Emp.announcement = false;
        Emp.attendanceUpload = false;
        Emp.peopleSearch = false;
        Emp.exits = false;
        Emp.exitsFnF = false;
        Emp.onBoarding = false;
        Emp.onBoardingExpected = false;
        Emp.leave = false;
        Emp.upload = false;
        Emp.download = false;
        Emp.ctcSplit = false;
        Emp.abscond = false;
      }
      else {
        Emp.superAdmin = new_Emp.data.roles.superAdmin == 1;
        Emp.it = new_Emp.data.roles.it == 1;
        Emp.hr = new_Emp.data.roles.hr == 1;
        Emp.finance = new_Emp.data.roles.finance == 1;
        Emp.admin = new_Emp.data.roles.admin == 1;
        Emp.hrbp = new_Emp.data.roles.hrbp == 1;
        Emp.recruiter = new_Emp.data.roles.recruiter == 1;
        Emp.roster = new_Emp.data.roles.roster == 1;
        Emp.inspector = new_Emp.data.roles.inspector == 1;
        Emp.announcement = new_Emp.data.roles.announcement == 1;
        Emp.attendanceUpload = new_Emp.data.roles.attendanceUpload==1;
        Emp.peopleSearch = new_Emp.data.roles.peopleSearch==1;
        Emp.exits = new_Emp.data.roles.exits==1;
        Emp.exitsFnF = new_Emp.data.roles.exitsFnF==1;
        Emp.onBoarding = new_Emp.data.roles.onBoarding==1;
        Emp.onBoardingExpected = new_Emp.data.roles.onBoardingExpected==1;
        Emp.leave = new_Emp.data.roles.leave==1;
        Emp.upload = new_Emp.data.roles.upload==1;
        Emp.download = new_Emp.data.roles.download==1;
        Emp.ctcSplit = new_Emp.data.roles.ctcSplit==1;
        Emp.abscond = new_Emp.data.roles.abscond==1;
      }
      Emp.manager = new_Emp.data.isManager;
      Emp.vertical = new_Emp.data.isVertical;
      Emp.isLastWorkingDay = new_Emp.data.isLastWorkingDay;



      call6.then((response)=>{
              Emp.personal = response.data.data;
              Emp.reportingToEmpID = response.data.data.employee.reportingTo;
              dispatch(storeEmp(Emp));
            }).catch((error)=>{
              console.log(error);
      });

          }).catch((error)=> {
            console.log(error);
          })
  };
}



/** WEBPACK FOOTER **
 ** ./src/redux/actions/empActions.js
 **/